import { render, staticRenderFns } from "./DashboardConvenio.vue?vue&type=template&id=66e9dc30&scoped=true&"
import script from "./DashboardConvenio.vue?vue&type=script&lang=js&"
export * from "./DashboardConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9dc30",
  null
  
)

export default component.exports